class Tooltip {
  constructor(obj, position, content) {
    this.el = obj;
    this.position = position || 'bottom';
    this.content = content || '';
    this.tooltip = this.create();
    this.setPosition();
    this.bindEvents();
  }

  create() {
    const tooltip = document.createElement('div');
    tooltip.className = 'c-tooltip';
    tooltip.innerHTML = this.content;
    tooltip.style.position = 'absolute';
    document.body.appendChild(tooltip);
    tooltip.style.display = 'none';
    return tooltip;
  }

  bindEvents() {
    this.el.addEventListener('mouseenter', () => {
      this.showTooltip();
    });
    this.el.addEventListener('mouseleave', () => {
      this.hideTooltip();
    });
    window.addEventListener('scroll', () => {
      this.setPosition();
    });
    window.addEventListener('resize', () => {
      this.setPosition();
    });
  }

  setPosition() {
    const tooltipClass = `c-tooltip--${this.position}`;
    const position = {
      left: null,
      top: null,
    };
    switch (this.position) {
      case 'bottom':
        (() => {
          position.left = this.getPosition().center;
          position.top = this.getPosition().bottom;
        })();
        break;
      case 'top':
        (() => {
          position.left = this.getPosition().center;
          position.top = this.getPosition().top;
        })();
        break;
      case 'left':
        (() => {
          position.left = this.getPosition().left;
          position.top = this.getPosition().middle;
        })();
        break;
      case 'right':
        (() => {
          position.left = this.getPosition().right;
          position.top = this.getPosition().middle;
        })();
        break;
      default:
        (() => {
          position.left = this.getPosition().center;
          position.top = this.getPosition().top;
        })();
    }
    this.tooltip.classList.add(tooltipClass);
    this.tooltip.style.left = `${position.left}px`;
    this.tooltip.style.top = `${position.top}px`;
    return position;
  }

  getPosition() {
    const { el, tooltip } = this;
    const elOffset = {
      top: el.getBoundingClientRect().top + window.pageYOffset - document.body.clientTop,
      left: el.getBoundingClientRect().left + window.pageXOffset - document.body.clientLeft,
    };
    return {
      center: (() => elOffset.left + el.offsetWidth / 2 - tooltip.offsetWidth / 2)(),
      top: (() => elOffset.top - tooltip.offsetHeight)(),
      bottom: (() => elOffset.top + el.offsetHeight)(),
      middle: (() => elOffset.top + el.offsetHeight / 2 - tooltip.offsetHeight / 2)(),
      left: (() => elOffset.left - tooltip.offsetWidth)(),
      right: (() => elOffset.left + el.offsetWidth)(),
    };
  }

  showTooltip() {
    this.tooltip.style.display = 'block';
    this.setPosition();
    this.onShow(this.tooltip);
  }

  hideTooltip() {
    this.onHide(this.tooltip);
    this.tooltip.style.display = 'none';
  }

  onShow() {
    return false;
  }

  onHide() {
    return false;
  }
}

export default Tooltip;
